// The to-do list's three columns share one set of grid rows (title /
// description / filters / action / list) so every list starts at the same
// height whatever the length of the text above it. Below `lg` the columns
// simply stack.
export const TODO_COLUMN_CLASS =
  "min-w-0 lg:row-span-5 lg:grid lg:grid-rows-subgrid";
